<template>
	<div class="o-container o-container--thin">
		<preloader-view class="o-v-rhythm--small" />
	</div>
</template>

<script>
    import retrieveDataFromHash from '../../helpers/retrieveDataFromHash';
  import { mapGetters, mapState } from 'vuex';
	import renderError from '../../utils/renderErrorMessage';
	import PreloaderView from '../views/PreloaderView.vue';

	export default {
		components: {
			PreloaderView,
		},
		computed: {
			...mapState('onboarding', {
				onboardingcomplete: state => state.form.onboardingcomplete
			}),
            ...mapState('user', {
                user: state => state.user
            })
		},
		created() {
			this.fetchData();
		},
		methods: {
      ...mapGetters('onboarding', ["subscribedToFanOffer"]),
			fetchData() {
				const tokens = retrieveDataFromHash( this.$route.hash );

				tokens.error_description ?
					this.onError(tokens.error_description) :
					this.onSuccess(tokens);
			},
			onError(error) {
				const errorText = renderError({
					code: 'UserLambdaValidationException',
					message: decodeURIComponent((error+'').replace(/\+/g, '%20')),
				});

				this.$router.push({
					name: 'login',
					params: {
						message: {
							value: errorText
						}
					}
				});
			},
			onSuccess(tokens) {

				this.$store.dispatch('user/LOGIN_SOCIAL_PROVIDER', tokens).then((state) => {
					this.$store.dispatch('user/RETRIEVE_USER').then(() => {
						this.$store.dispatch('user/RETRIEVE_USER_REPEATED_SOCIAL').then(async () => {
              if (this.subscribedToFanOffer()) {
                // await this.$store.dispatch('onboarding/OPTIN', {optin: true});
              }
              if (this.onboardingcomplete === 'Not Completed') {
                // redirect to the Onboarding page
                this.$router.push({name: 'onBoarding'});
              } else {
                // redirect to the My Account page
                this.$router.push({name: 'myAccount'});
              }
            })
						.catch((err) => {
							// redirect to the My Account page
							this.$router.push({name: 'myAccount'});
						});
					});
				});
			}
		}
	}
</script>
